import router from './router';
import ApplicationFormAPI from "./services/ApplicationFormAPI";

var manageAutoSaveFn;
var autoSaveInterval = 0;

window.editApplicationForm = function () {
	router.push($("#isFormTemplate").val() == "true" ? process.env.VUE_APP_CONTEXT_PATH + "/design/formTemplates/" + $('#templateId').val() : process.env.VUE_APP_CONTEXT_PATH + "/design/applications/" + $('#applicationId').val() + "/appforms/" + $('#formId').val());
}

window.updateFormDesigner = function (inputData) {
	inputData = JSON.stringify(inputData);
	window.formDesignHasChanged = false;
	var data = {
		designerJson: inputData,
		renderedJson: inputData
	};
	let url = $("#isFormTemplate").val() == "true"
		? "/templates/form-template/" +
		$("#templateId").val() +
		"/save-form-design"
		: "/applications/" +
		$("#applicationId").val() +
		"/appforms/" +
		$("#formId").val() +
		"/saveFormDesign";
	ApplicationFormAPI.saveFormDesign(url, data).then(response => {
		if (response.error) {
			showToast('danger', 'Could not process your request');
		} else {
			showToast('success', 'Form designer saved successfully');
		}
	});

}

window.showImportFromForm = function () {
	clearDropDown("#selectFormImportCmp");
	ApplicationFormAPI.getFormsForImport().then((responseData) => {
		$.each(responseData, function (i, value) {
			if ($("#formId").val() != value.id) {
				$("#selectFormImportCmp").append(
					$("<option>").text(value.name).attr("value", value.id)
				);
			}
		});
	});
	$("#importFromFormDialog").parent().addClass("mu-visible");
	const select = new SlimSelect({
		select: '#selectFormImportCmp',
		placeholder: 'Select your options',
		openPosition: 'down',       
	  })
};

window.clearDropDown = function (cmpId) {
	$(cmpId).find('option').remove();
	$(cmpId).append($('<option>').text('').attr('value', ''));
}

window.importFormTemplate = function () {
	$("#appendFormTemplate").val(false);
	showFormTemplateData();
}

window.navigateToHelpPage = function () {
	$("#formDesignerHelp")[0].click();
}

function showFormTemplateData() {
	clearDropDown('#selectTemplateCmp');
	ApplicationFormAPI.getAllFormTemplates().then((responseData) => {
		$.each(responseData, function (i, value) {
			if (($("#isFormTemplate").val() == "true" && $('#formId').val() != value.id)
				|| $("#isFormTemplate").val() == "false") {
				$("#selectTemplateCmp").append(
					$("<option>").text(value.name).attr("value", value.id)
				);
			}
		});
	});
	$("#selectTemplateDialog").parent().addClass("mu-visible");
	const select = new SlimSelect({
		select: '#selectTemplateCmp',
		placeholder: 'Select your options',
		openPosition: 'down',           
	  })
}

window.displayAutoSaveModal = function () {
	$("#interval").off('invalid')
	$("#interval").on('invalid', (e) => {
		let data = { property: { label: "Interval", minValue: 60, maxValue: 1760 } };
		let errorMessage = window.getValidationErrorMessage(e, data);
		$(e.target).siblings('.mfc-invalid-feedback').text(errorMessage);
	});
	getAutoSaveDataForUser();
	$("#autoSaveConfigDialog").parent().addClass("mu-visible");
	$("#autoSaveConfigDialog")[0].showModal();
}

window.getAutoSaveDataForUser = function () {
	$("#interval").removeAttr("invalid");
	ApplicationFormAPI.getAutoSaveData().then((responseData) => {
		if (responseData) {
			$("#autoSaveFormDesigner").prop("checked", responseData.autoSaveFormDesigner);
			handleAutoSaveChange();
			if (responseData.autoSaveFormDesigner) {
				$("#interval").val(responseData.autoSaveIntervalFormDesigner);
			}
			autoSaveInterval = responseData.autoSaveIntervalFormDesigner;
			manageAutoSave();
		}
	});
}

function showToast(color, title) {
	const getIcon = (color) => {
	  switch (color) {
		case 'info':
		  return 'info_popup'
		case 'success':
		  return 'ok'
		case 'warning':
		  return 'error'
		case 'danger':
		  return 'stop_sign'
		case 'primary':
		  return 'page'
		default:
		  return 'not_found'
	  }
	}

	const buildToastText = () => {
	  return `
		<mcc-icon name="${getIcon(color)}" icon-set="fluency-filled" aria-hidden="true"></mcc-icon>
		<div class="mu-d-flex mu-flex-column">
		  <div class="mu-fw-semi-bold">${title}</div>
		</div>
	  `
	}

	Toastify({
	  text: buildToastText(),
	  escapeMarkup: false,
	  duration: 5000, 
	  newWindow: true,
	  close: true,
	  className: `mcc-alert  mcc-alert--${color} [mu-d-flex mu-flex-row mu-p-04 mu-px-05]`,
	  gravity: "top",
	  position: "right", 
	  stopOnFocus: true, 
	}).showToast() 
  }

window.resetAutoSave = function () {
	if (
		manageAutoSaveFn !== undefined &&
		manageAutoSaveFn != null
	) {
		try {
			clearInterval(manageAutoSaveFn);
		} catch (e) {
			return false;
		}
	}
	manageAutoSave();
}

function manageAutoSave() {
	if (autoSaveInterval > 0) {
		manageAutoSaveFn = setInterval(function () {
			if (window.formDesignHasChanged) {
				autoSaveFormDesigner();
				window.formDesignHasChanged = false;
			}
		}, autoSaveInterval * 1000);
	}
}

window.handleAutoSaveChange = function () {
	let autoSave = $("#autoSaveFormDesigner").prop("checked");
	if (!autoSave) {
		$("#interval").removeAttr("required");
		$("#interval").removeAttr("invalid");
		$("#interval").val("");
		$("#interval").prop("disabled", true);
	} else {
		$("#interval").val(60);
		$("#interval").removeAttr("disabled");
		$("#interval")[0].setAttribute("required", "true");
	}
}

window.setAutoSaveInternal = function (interval) {
	autoSaveInterval = interval;
}

function autoSaveFormDesigner() {
	let inputData = JSON.stringify(
		window.formDesignerAppComponent.getUpdatedJsonFn()
	);
	let data = {
		designerJson: inputData,
		renderedJson: inputData,
	};
	let url = $("#isFormTemplate").val() == "true"
		? "/templates/form-template/" +
		$("#templateId").val() +
		"/save-form-design"
		: "/applications/" +
		$("#applicationId").val() +
		"/appforms/" +
		$("#formId").val() +
		"/saveFormDesign";
	ApplicationFormAPI.saveFormDesign(
		url,
		data
	).then((response) => {
		getFormHistoryData();
	});
}

window.getFormHistoryData = function () {
	let url = $("#isFormTemplate").val() == "true"
		? "/templates/form-template/" + $("#templateId").val() + "/form-history"
		: "/applications/" +
		$("#applicationId").val() +
		"/appforms/form-history/" +
		$("#formId").val();
	ApplicationFormAPI.getFormHistoryData(url).then((responseData) => {
		$.each(responseData, function (i, value) {
			responseData[i][1] = new Date(value[1])
				.toLocaleString("en-GB")
				.replace(/\,/g, "");
		});
		window.formDesignerAppComponent.showFormHistoryFn(responseData);
	});
}

window.appendFormTemplateFn = function () {
	$("#appendFormTemplate").val("true");
	showFormTemplateData();
}